<script setup lang="ts">
defineProps<{
  label: string;
  description?: string;
  icon?: string;
  trailingLabel?: string;
}>();
</script>

<template>
  <div class="flex items-center gap-3 min-w-0 w-full text-primary">
    <div class="flex flex-col min-w-0 grow">
      <span class="text-base/normal font-semibold truncate">{{ label }}</span>
      <span v-if="description" class="text-sm/[1.429] text-gray-600 truncate">{{ description }}</span>
    </div>
    <div class="shrink-0">
      <slot v-if="$slots.trailing" name="trailing" />
      <UButton v-else-if="trailingLabel" as="span" color="secondary" size="md">{{ trailingLabel }}</UButton>
      <UIcon v-else-if="icon" :name="icon" class="size-4" />
    </div>
  </div>
</template>
